/** Bloque de código con botón de copiar (curl, JSON, URLs). Presentacional; el copiado va por hooks/useCopy. */
import { Copy } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import { useCopy } from '@/hooks/useCopy';
import { cn } from '@/lib/utils';

export function CodeBlock({ code, label, className }: { code: string; label?: string; className?: string }) {
  const { t } = useTranslation();
  const copy = useCopy();
  return (
    <div className={cn('relative rounded-md border bg-muted/40', className)}>
      {label && <div className="border-b px-3 py-1 text-xs text-muted-foreground">{label}</div>}
      <pre className="overflow-x-auto p-3 pr-12 text-xs leading-relaxed"><code>{code}</code></pre>
      <Button type="button" size="sm" variant="ghost" className="absolute right-1 top-1 h-7 px-2" onClick={() => copy(code)} aria-label={t('common.copy', 'Copiar')}>
        <Copy className="h-3.5 w-3.5" />
      </Button>
    </div>
  );
}
